<template>
  <div class="product">
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="left-side pa-0 px-2 mb-4">
          <v-card>
            <v-carousel 
              cycle 
              hide-delimiters
              :show-arrows="false"
              :interval="carouselInterval"
              v-model="index"
            >
              <div style="padding-top: calc(100% / 1.75)" v-if="!Object.keys(product).length"></div>
              <v-skeleton-loader height="100%" width="100%" type="image" v-if="!Object.keys(product).length"></v-skeleton-loader>
              <Watermark v-if="isLogin" :mark="user.id | member"></Watermark>
              <v-carousel-item 
                class="video-container" 
                v-for="(video, i) in product.video_info" 
                :key="i"
              >
                <video-player 
                  v-once
                  :ref="`video${i}`"
                  :playsinline="true" 
                  @canplay="$refs[`video${i}`][0].player.play()"
                  @playing="carouselInterval = 99999999"
                  @pause="carouselInterval = 5000"
                  @ended="carouselInterval = 5000"
                  :options="$func.videoOption({
                    src: $HOST_URL + video.uuid_path,
                    autoplay: $videojs.browser.IS_SAFARI ? true : false,
                    muted: true,
                    loop: false,
                    controls: true,
                    poster: $HOST_URL + video.preview_path
                  })"></video-player>
              </v-carousel-item>
              <v-carousel-item
                v-for="image in product.image_info"
                :src="$HOST_URL + image.uuid_path"
              >
              </v-carousel-item>
            </v-carousel>
            <div class="preview-container">
              <button class="control-btn left" @click="previewMove('left')">
                <v-icon small color="white">fa-chevron-left</v-icon>
              </button>
              <button class="control-btn right" @click="previewMove('right')">
                <v-icon small color="white">fa-chevron-right</v-icon>
              </button>
              <v-row class="img-preview pt-1 flex-nowrap" style="transform: translateX(0)">
                <v-col 
                  cols="4" 
                  sm="3"
                  v-for="(video, i) in product.video_info" 
                  :class="[{isPreview: (index == i)}, 'd-flex align-center justify-center']"
                  @mouseenter="index = i"
                >
              <!--     <div class="play">
                    <v-icon color="grey lighten-1" large>fa-play-circle</v-icon>
                  </div> -->
                  <v-img aspect-ratio="1.75" v-auth-src="$HOST_URL + video.preview_path"></v-img>
                </v-col>
                <v-col 
                  cols="4" 
                  sm="3"
                  v-for="(image, i) in product.image_info" 
                  :class="{isPreview: (index == product.video_info.length + i)}"
                  @mouseenter="index = product.video_info.length + i"
                >
                  <v-img aspect-ratio="1.75" v-auth-src="$HOST_URL + image.uuid_path"></v-img>
                </v-col>
              </v-row>
            </div>
            <div class="pa-6">
              <div style="min-height: 27px">
                <h3>
                  <template v-if="product.title">
                    {{ product.title }}
                    <v-btn 
                      v-if="purchaseID.includes(product.id) && product.product_type != 'clothes'" 
                      icon 
                      color="pink" 
                      class="float-right" 
                      @click="like"
                    >
                      <v-icon v-if="likeID.includes(product.id)">fa-thumbs-up</v-icon>
                      <v-icon v-else>far fa-thumbs-up</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-skeleton-loader dark type="table-cell"></v-skeleton-loader>
                  </template>
                  <div class="review text-right mt-2">
                    <template v-if="product.product_type == 'clothes'">
                      <v-icon>fa-eye</v-icon>
                      <span>{{ product.views }}</span>
                    </template>
                    <template v-else-if="product.product_type == 'video'">
                      <v-icon>fa-thumbs-up</v-icon>
                      <span>{{ mul(product.praise_rate, 100) }}%</span>
                      <v-icon>fa-unlock</v-icon>
                      <span>{{ product.unlocks }}</span>
                    </template>
                  </div>
                </h3>
              </div>
              <v-divider color="grey" class="my-3"></v-divider>
              <div
                v-if="product.seller_info"
                class="mb-3 d-flex align-center pointer"
                @click="$router.push(`/seller/${product.seller_info.id}`)"
              >
                <v-avatar size="40" class="mr-2">
                  <v-img :src="$HOST_URL + product.seller_info.usericon"/>
                </v-avatar>
                {{ product.seller_info.nickname }}
                <v-spacer></v-spacer>
              </div>
              <div class="d-flex align-center">
                <div class="user-information">
                  <template v-if="product.seller_info">
                    <div>年齡: <span>{{ product.seller_info.age }}</span></div>
                    <div>三圍: <span>{{ product.seller_info.bust }} / {{ product.seller_info.waist }} / {{ product.seller_info.hips }}</span></div>
                    <div>罩杯: <span>{{ product.seller_info.cup }}</span></div>
                    <div>身高: <span>{{ product.seller_info.height }}cm</span></div>
                    <div>體重: <span>{{ product.seller_info.weight }}kg</span></div>
                    <div>興趣: <span>{{ product.seller_info.interest }}</span></div>
                    <div>居住城市: <span>{{ product.seller_info.city }}</span></div>
                    <div>職業: <span>{{ product.seller_info.job }}</span></div>
                    <div v-if="product.product_type == 'clothes'">使用時間: 
                      <span>{{ product.use_time }}hrs 
                          <span class="caption grey--text">(數據由主播提供，僅供參考)</span>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <v-skeleton-loader dark class="pr-4" type="avatar, paragraph"></v-skeleton-loader>
                  </template>
                </div>
                <v-spacer></v-spacer>
                <div class="text-center">
                  <v-btn 
                    outlined 
                    color="pink" 
                    height="70" 
                    min-width="120" 
                    @click="buy"
                    >
                    <div class="buy">
                      <template v-if="product.price === 0">
                        免費觀看
                      </template>
                      <template v-else-if="purchaseID.includes(product.id)">
                        {{ product.product_type == 'clothes' ? '已售出' : '已解鎖' }}
                      </template>
                      <template v-else>
                        <div class="d-flex align-center mb-1">
                          <div class="peach" :style="isDisabled ? 'filter: grayscale(100%)' : ''"></div>
                          {{ product.price }}
                        </div>
                        <div v-if="product.product_type == 'clothes'">加入購物車</div>
                        <div v-else-if="product.product_type == 'video'">立即解鎖</div>
                      </template>
                    </div>
                  </v-btn>
                  <div class="pink--text caption mt-1" v-if="isDisabled">此商品已售出</div>
                </div>
              </div>
              <div class="pt-6 pb-2">{{ product.remark }}</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="right-side pa-0 px-2">
          <v-row no-gutters>
            <v-col 
              cols="12" sm="6" md="12" lg="12" xl="12" class="other-product" 
              v-for="(otherProduct, i) in otherProducts"
              :key="i"
            >
              <v-card 
                :to="`/product/${otherProduct.id}`"
                @mouseover="otherProduct.product_type == 'video' ? $func.startPlayVideo($refs, i, $HOST_URL + otherProduct.video_info[0].uuid_path) : ''"
                @mouseleave="otherProduct.product_type == 'video' ? $func.stopPlayVideo($refs, i) : ''"
              >
                <div class="user">
                  <v-avatar size="40" class="mr-2">
                    <v-img :src="$HOST_URL + product.seller_info.usericon"/>
                  </v-avatar>
                  <div v-if="product.seller_info">{{ product.seller_info.nickname }}</div>
                </div>
                <video-player 
                  v-if="otherProduct.product_type == 'video'"
                  v-once
                  :ref="`video${i}`"
                  class="video-player" 
                  :playsinline="true" 
                  @canplay="$func.onPlayerCanplay($event, i)"
                  :options="$func.videoOption({
                    src: $HOST_URL + otherProduct.video_info[0].uuid_path,
                    autoplay: false,
                    muted: true,
                    loop: false,
                    controls: true,
                    poster: $HOST_URL + otherProduct.video_info[0].preview_path
                  })"></video-player>
                <v-img 
                  v-else
                  :src="$HOST_URL + otherProduct.image_info[0]" 
                  aspect-ratio="1.75" 
                ></v-img>
                <div class="pa-2">
                  <div class="mb-2">{{ otherProduct.title }}</div>
                  <div class="d-flex justify-space-between">
                    <div class="d-flex align-center">
                      <div class="peach"></div>
                      <span class="pink--text">{{ otherProduct.price }}</span>
                    </div>
                    <span class="caption grey--text d-flex align-center">
                      <v-icon small class="mr-1" color="grey">
                        {{ product.product_type == 'clothes' ? 'fa-eye' : 'fa-unlock' }}
                      </v-icon>
                      {{ product.product_type == 'clothes' ? product.views : product.unlocks }}
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <SoldoutDialog ref="soldoutDialog"></SoldoutDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SoldoutDialog from '@/components/SoldoutDialog'
import Watermark from '@/components/Watermark'
export default {
  components: { SoldoutDialog, Watermark },
  data() {
    return {
      index: 0,
      carouselInterval: 5000,
      product: {},
      otherProducts: [],
    }
  },
  mounted() {
    this.start()
  },
  beforeRouteUpdate(to, from, next) {
    this.$route.params.id = to.params.id
    this.start()
    next()
  },
  computed: {
    ...mapState('global', ['seller_job_types']),
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isLogin', 'purchaseID', 'likeID']),
    isDisabled() {
      return this.product.product_type == 'clothes' && (this.product.sold > 0 || this.product.shelf == 0)
    }
  },
  watch: {
    seller_job_types() {
      if(this.product.seller_info) {
        this.product.seller_info.job = this.seller_job_types.find(type => type.num == this.product.seller_info.job).name
      }
    }
  },
  methods: {
    start() {
      this.getProduct().then(() => {
        this.$store.dispatch('global/viewCount', this.product.id)
        if(this.isDisabled && !this.purchaseID.includes(this.product.id)) {
          this.$refs.soldoutDialog.dialog = true
        }
        document.title = `${this.product.title} - ${this.$TITLE}`
        // this.getOtherProducts()
        // this.videoPlayingListener()
      })
      window.addEventListener('resize', () => {
        document.getElementsByClassName('img-preview')[0].style.transform = 'translateX(0)'
      })
    },
    previewMove(direction) {
      let preview = document.getElementsByClassName('img-preview')[0]
      let width = document.getElementsByClassName('img-preview')[0].children[0].offsetWidth
      let value = parseFloat(preview.style.transform.slice(11, preview.style.transform.length - 1))
      if(direction == 'left') {
        if(value == 0) {
          return
        }
        preview.style.transform = `translateX(${value + width}px)`
      }
      else if(direction == 'right') {
        if(Math.abs(value - (preview.offsetWidth - (this.product.image_info.length + this.product.video_info.length) * width)) <= 5) {
          return
        }
        preview.style.transform = `translateX(${value - width}px)`
      }
    },
    getProduct() {
      return this.axios.get(`/product/${this.$route.params.id}?includeSeller=true`).then(response => {
        this.product = response.data
        if(this.seller_job_types.length > 0) {
          this.product.seller_info.job = this.seller_job_types.find(type => type.num == this.product.seller_info.job).name
        }
      })
    },
    getOtherProducts() {
      this.axios.post('/products/condition', {
        search : [
          {table: 'sellers', column: 'id', keyword: [this.product.seller_id, this.product.seller_id]},
          {table: 'products', column: 'shelf', keyword: [1, 1]},
          {table: 'products', column: 'sold', keyword: [0, 0]}
        ],
        sort: {
          table: 'products',
          column: 'priority',
          by: 'desc'
        },
        page: 1, 
        size: 7
      }).then(response => {
        this.otherProducts = response.data.data
        // .filter(product => product.id != this.product.id).splice(0, 6)
      })
    },
    buy() {
      if(this.product.price !== 0 && !this.purchaseID.includes(this.product.id)) {
        if(this.product.product_type == 'video') {
          this.$root.$emit('confirmDialog', this.unlock, `確定支付 <span class='d-inline-flex pink--text'><div class='peach'></div>${this.product.price}</span> 解鎖該影片？`)
        }
        else {
          this.addToShoppingCart()
        }
      }
    },
    addToShoppingCart() {
      this.axios.post('/member/cart', {
        product_id: this.product.id
      }).then(response => {
        this.$store.dispatch('shoppingCart/getShoppingCartProducts')
        this.$root.$emit('alert', 'success', '已新增到購物車')
      }).catch(e => {
        if(e.response.status == 401) {
          this.$router.push('/login')
        }
        else if(e.response.data.message.includes('There are products in the request sold')) {
          this.$refs.soldoutDialog.dialog = true
        }
        else if(e.response.data.message.includes('same product in the cart')) {
          this.$root.$emit('alert', 'error', '該商品已在購物車')
        }
        else {
          this.$root.$emit('alert', 'error', '新增失敗')
        }
      })
    },
    unlock() {
      this.axios.post('/member/online/buy', {
        product_id: this.product.id
      }).then(response => {
        this.$root.$emit('alert', 'success', '解鎖成功')
        this.$store.dispatch('user/getPurchaseID')
        this.$store.dispatch('user/getUserInformation')
        this.$refs[`video0`][0].player.src(this.$refs[`video0`][0].player.currentSrc())
        window.scrollTo(0, 0)
      }).catch(() => {
        this.$root.$emit('alert', 'error', '解鎖失敗')
      })
    },
    like() {
      this.axios.post('/member/praise', {
        product_id: this.product.id
      }).then(response => {
        this.$store.dispatch('user/getLikeID')
      })
    }
    // videoPlayingListener() {
    //   let videoElement = document.getElementsByTagName('video')[0]
    //   if(!videoElement) {
    //     return
    //   }
    //   videoElement.addEventListener('playing', () => {
    //     this.carouselInterval = 99999999
    //   })
    //   videoElement.addEventListener('ended', () => {
    //     this.carouselInterval = 5000
    //   })
    //   videoElement.addEventListener('pause', () => {
    //     this.carouselInterval = 5000
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.product {
  min-height: 100%;
  .v-card {
    position: relative;
    .v-window {
      height: unset !important;
      .v-carousel__item {
        height: unset !important;
        .v-responsive__sizer {
          padding-bottom: 0 !important;
        }
        .v-responsive__content {
          padding-bottom: 57.1429% !important;
          .video-player {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          }
        }
      }
      .v-skeleton-loader {
        position: absolute;
        top: 0;
        left: 0;
        .v-skeleton-loader__image {
          height: 100%;
        }
      }
    }
  }
  .container {
    max-width: 1200px;
    .left-side .v-card, .right-side .v-card {
      background-color: $grey-3 !important;
      color: white;
    }
  }
  .user-information {
    font-size: 14px;
    font-weight: 100;
    padding-right: 10px;
    flex-grow: 5;
    span {
      margin-left: 10px;
    }
    .v-skeleton-loader {
      div {
        margin: 10px 0;
      }
    }
  }
  .buy {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .preview-container {
    position: relative;
    overflow-x: hidden;
    .control-btn {
      position: absolute;
      width: 30px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }
    .left {
      left: 0;
      top: 0;
      background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, .5));
      &:hover {
        background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, .8));
      }
    }
    .right {
      right: 0;
      top: 0;
      background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .5));
      &:hover {
        background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .8));
      }
    }
    .img-preview {
      margin: 0;
      transition: transform .3s ease;
      & > div {
        padding: 5px;
      }
      .isPreview {
        border: 2px $main solid;
        cursor: pointer;
      }
      .play {
        position: absolute;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: black;
        width: 34px;
        height: 34px;
      }
    }
  }
  .other-product {
    padding: 6px;
    .user {
      padding: 8px;
      display: flex;
      align-items: center;
      & > div {
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  audio {
    margin-left: 15px;
    height: 30px;
    width: 230px;
  }
}
</style>